
import { DEFAULT_RADIUS } from '../../../util/constants'

export default {
    props: {
    routeValidation: {
      type: Boolean,
      default: false
    },
    filterProp: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      DEFAULT_RADIUS,
      radiusCommon: DEFAULT_RADIUS,
      isValid: true
    };
  },
  watch: {
    filterProp: {
      handler() {
        if (this.filterProp !== null) {
            this.radiusCommon = this.filterProp
            this.$emit('value-changed', this.radiusCommon)
        } else {
          this.radiusCommon = DEFAULT_RADIUS
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    handleChange () {
      this.$emit('value-changed', this.radiusCommon)
    },
    isRadiusValid(){
      return (this.radiusCommon && this.radiusCommon>= 25)
    }
  }
}
